var e = "10.31.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
